import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import PageShell from '../components/Layout/PageShell'
import { RsIcon } from '../components/icons'
import axios from 'axios'
import toast from 'react-hot-toast'

const KIND_STYLES = {
  fundraise: 'badge-blue',
  asset_sale: 'badge-green',
}

export default function Listings() {
  const navigate = useNavigate()
  const [listings, setListings] = useState([])
  const [filter, setFilter] = useState('all')
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const load = async () => {
      try {
        const q = filter === 'all' ? '' : `?type=${filter === 'fundraise' ? 'deal' : 'asset'}`
        const res = await axios.get(`/api/listings${q}`)
        setListings(res.data.listings || [])
      } catch {
        toast.error('Failed to load listings')
      } finally {
        setLoading(false)
      }
    }
    load()
  }, [filter])

  return (
    <PageShell>
        <div className="flex justify-between items-center mb-6">
          <div>
            <h1 className="text-2xl font-bold text-navy">Listings Hub</h1>
            <p className="text-gray-500 text-sm mt-1">Browse GP fundraising deals and asset sales in one place</p>
          </div>
          <div className="flex gap-2">
            {[
              { id: 'all', label: 'All' },
              { id: 'fundraise', label: 'Fundraise Deals' },
              { id: 'asset_sale', label: 'Asset Sales' },
            ].map((tab) => (
              <button
                key={tab.id}
                type="button"
                onClick={() => {
                  setLoading(true)
                  setFilter(tab.id)
                }}
                className={`px-4 py-2 rounded-lg text-sm font-medium ${
                  filter === tab.id ? 'bg-primary-500 text-white' : 'bg-white text-gray-600 border border-gray-200'
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        {loading ? (
          <p className="text-gray-400 text-sm">Loading…</p>
        ) : (
          <div className="grid gap-4">
            {listings.map((item) => (
              <div
                key={`${item.listingType}-${item.id}`}
                className="card p-5 flex items-center justify-between hover:shadow-md transition-shadow cursor-pointer"
                onClick={() => {
                  const path = item.detailPath || (item.listingType === 'deal' ? '/deals' : '/assets')
                  navigate(path)
                }}
                role="button"
                onKeyDown={(e) => e.key === 'Enter' && navigate(item.detailPath || '/deals')}
              >
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-lg bg-primary-50 flex items-center justify-center">
                    <RsIcon name="briefcase" size={20} className="w-5 h-5 text-primary-500" />
                  </div>
                  <div>
                    <div className="flex items-center gap-2 mb-1">
                      <span className={`badge ${KIND_STYLES[item.kind] || 'badge-blue'}`}>{item.kindLabel}</span>
                      <span className="text-xs text-gray-400">{item.phase}</span>
                    </div>
                    <h3 className="font-semibold text-navy">{item.title}</h3>
                    <p className="text-sm text-gray-500 mt-1">
                      {item.ownerName} · {item.amountLabel || item.industry || '—'}
                    </p>
                  </div>
                </div>
                <div className="text-right">
                  <div className="w-32 bg-gray-200 rounded-full h-2 mb-1">
                    <div className="bg-primary-500 h-2 rounded-full" style={{ width: `${item.progress}%` }} />
                  </div>
                  <span className="text-xs text-gray-500">{item.progress}%</span>
                </div>
              </div>
            ))}
            {!listings.length && (
              <div className="card p-12 text-center text-gray-400">
                <RsIcon name="filter" size={32} className="w-8 h-8 mx-auto mb-2 opacity-40" />
                <p>No listings</p>
              </div>
            )}
          </div>
        )}
    </PageShell>
  )
}
